import type { SiteConfig } from '../types';

/**
 * Standards archive — brand palette lifted from the live deployment
 * (theme/standards.less: @bg-green-1 #057c5a, @bg-green-2 #5a93aa,
 * @bg-red-1 hsl(349,86%,36%) ≈ #a80d2a). DOE / energy.gov branding removed.
 */
const standards: SiteConfig = {
  id: 'standards',
  pathPrefix: 'standards',
  baseUrl: 'https://archives.standards.doxcelerate.com',
  title: 'Technical Standards',
  tagline: 'Archive of technical standards documents',
  seoName: 'DOE Technical Standards Archive',
  seoDescription:
    'An independent archive of DOE technical standards, handbooks, ' +
    'and specifications. Published by Doxcelerate Corporation — not ' +
    'an official DOE site.',
  colors: {
    primary: '#057c5a',
    secondary: '#024d38',
    accent: '#a80d2a',
  },
  ga4: 'G-Q2QZXDGW2L',
  nav: [
    { label: 'Home', to: '/' },
    { label: 'Documents', to: '/documents' },
    { label: 'People', to: '/people' },
    { label: 'Search', to: '/search' },
    { label: 'About', to: '/about' },
    { label: 'Contact', to: '/contact' },
  ],
  disclaimer:
    'This is an independent archive operated by Doxcelerate Corporation. It is not affiliated with, endorsed by, or operated by the U.S. Department of Energy. Documents are reproduced for reference; where this archive and the official DOE site disagree, the official site is correct.',
  footerGroups: [
    {
      heading: 'Browse',
      links: [
        { label: 'All Documents', to: '/documents' },
        { label: 'People', to: '/people' },
        { label: 'Search', to: '/search' },
      ],
    },
    {
      // Cross-links between the archives + the corporate site. These are
      // the only inbound links the sister archives have - keep them.
      heading: 'More from Doxcelerate',
      links: [
        { label: 'DOE Directives Archive', to: 'https://archives.directives.doxcelerate.com/', external: true },
        { label: 'NNSA Policies & Directives Archive', to: 'https://archives.nnsa.doxcelerate.com/', external: true },
        { label: 'Doxcelerate Corporation', to: 'https://www.doxcelerate.com/', external: true },
      ],
    },
  ],
  // Paste the token from each console here to verify this hostname.
  // null emits no tag; an empty string would emit a FAILED verification.
  verification: {
    google: null,
    bing: null,
  },
};

export default standards;
